import { ptacAmperageLabel } from '@alpinehomeair/common';

export const PTAC_ELECTRICAL_UNKNOWN_LABEL = 'Electrical rating unavailable';

export function ptacElectricalLabel(product: {
  voltage?: string | null;
  amperage?: number | null;
}): string {
  const parts = [
    product.voltage ? product.voltage : null,
    product.amperage ? ptacAmperageLabel(product.amperage) : null
  ].filter((part): part is string => part !== null);
  return parts.length > 0 ? parts.join(' · ') : PTAC_ELECTRICAL_UNKNOWN_LABEL;
}
